<template>
  <div class="app-container">
	<el-button style="margin: 20px 0px;" type="primary" plain icon="el-icon-plus" size="mini" >今日数据</el-button>
	<el-table :data="list"  border>
	  <el-table-column label="登录人数" align="center" prop="loginNumber" />
	  <el-table-column label="收礼人数" align="center" prop="receiveGiftsNumber" />
	</el-table>
	<el-button style="margin: 20px 0px;" type="primary" plain icon="el-icon-plus" size="mini" >本周数据</el-button>
	<el-table :data="wList"  border>
	  <el-table-column label="登录人数" align="center" prop="loginNumber" />
	  <el-table-column label="收礼人数" align="center" prop="receiveGiftsNumber" />
	</el-table>
	<el-button style="margin: 20px 0px;" type="primary" plain icon="el-icon-plus" size="mini" >本月数据</el-button>
	<el-table :data="mList"  border>
	  <el-table-column label="登录人数" align="center" prop="loginNumber" />
	  <el-table-column label="收礼人数" align="center" prop="receiveGiftsNumber" />
	</el-table>
  </div>
</template>

<script>
import { getGuildMemberStatisticsInfo } from "@/api/gonghui";
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 参数表格数据
      list: [],
	  wList:[],
	  mList:[],
      // 弹出层标题
      title: "成员统计",
      // 是否显示弹出层
      open: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        page:1,
		size:10,
		guildId:null,
		keyword:null
      },
    };
  },
  created() {
	const data = JSON.parse(Cookies.get('user'))
	this.queryParams.guildId = data.guildId
    this.getList();
  },
  methods: {
	
    /** 入会审批 */
	getList() {
	  this.loading = true;
	  getGuildMemberStatisticsInfo(this.queryParams).then(response => {
	    this.loading = false
		this.list = []
		this.wList = []
		this.mList = []
		this.list.push(response.data.toDayInfo)
		this.wList.push(response.data.currentWeekInfo)
		this.mList.push(response.data.currentMonthInfo)
	  });
	},
    

  }
};
</script>
<style>
	.el-table td, .el-table th{
		padding: 6px 0px;
	}
	.el-table{
		font-size: 12px;
	}
	.el-button+.el-button{
		margin-left: 0px;
	}
	.el-table th.gutter{
        display: table-cell!important;
    }
	
</style>


// WEBPACK FOOTER //
// chengyuantongji.vue?5c9f57e7